import { CheckDetailActions } from 'actions'
import IconButton from 'material-ui/IconButton'
import FontIcon from 'material-ui/FontIcon'
import BuildIcon from 'material-ui/svg-icons/action/build'
import VisibilityIcon from 'material-ui/svg-icons/action/visibility'
import VisibilityOffIcon from 'material-ui/svg-icons/action/visibility-off'
import { Link } from 'react-router'
import { Nav, Loading, VerdictBlock, Button, HelpLink } from 'components'
import { ResponsiveDialog } from 'common-frontend'

import './detailsHeader.scss'

export default class NotFoundDetailsHeader extends React.Component {
  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  static propTypes = {
    checkType:  React.PropTypes.object.isRequired,
    result:     React.PropTypes.object.isRequired,
    isFetching: React.PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      showHelpModal: false
    }
  }

  refresh() {
    CheckDetailActions.fetch({ id: this.props.checkType.id, refresh: true })
  }

  render() {
    const palette = this.context.muiTheme.palette

    return (
      <div>
        <Nav toolbarTitleText='Broken links'
          rightGroupComponents={[
            <IconButton
              key='help'
              tooltip='help'
              iconClassName="material-icons"
              iconStyle={{ color: palette.alternateTextColor }}
              onTouchTap={() => this.setState({ showHelpModal: true })}
            >
              help
            </IconButton>,
            <IconButton
              key='refresh'
              iconClassName="material-icons"
              iconStyle={{ color: palette.alternateTextColor }}
              tooltip='refresh this check'
              onTouchTap={::this.refresh}
            >
              refresh
            </IconButton>,
            <Link key='setup' to={`/checks/setup/${this.props.checkType.key}`}>
              <IconButton
                tooltip='setup'
                iconClassName="material-icons"
                iconStyle={{ color: palette.alternateTextColor }}
              >
                settings
              </IconButton>
            </Link>
          ]}
        />
        <div className='detailsHeader__url subhead' style={{ color: palette.alternateTextColor, backgroundColor: palette.accent2Color }} />
        <div className="detailsHeader__verdict-wrapper">    
          <VerdictBlock checkType={this.props.checkType} result={this.props.result} />
        </div>
        { this.props.isFetching &&
            <Loading wait={1000} />
        }
        <ResponsiveDialog
          title='How to use the Broken links checker'
          modal={false}
          open={this.state.showHelpModal}
          onRequestClose={() => this.setState({ showHelpModal: false })}
          maxWidth="650px"
        >
          <div>
            <h3 className="xlarge-spacing2--top">Getting setup</h3>
            <ol>
              <li>Install the <a href="https://support.pluginuseful.com/hc/en-us/articles/23534794660244-How-do-I-install-Plug-in-SEO-Plus-in-my-theme" target="_blank">Plug in SEO Plus code</a></li>
              <li className="medium-spacing--top">Press <FontIcon className="material-icons in-text-icon">settings</FontIcon> to choose your settings. Here you enter, for example, how many views a broken link should get before you want to be warned.</li>
              <li className="medium-spacing2--top">
                View the verdict and broken link detail
                <p className="medium-spacing2--top">Verdict example:</p>
                <div className="how-to-use__verdict-example">
                  <h5>Maybe worthwhile to fix</h5>
                </div>
                <p className="medium-spacing2--top">For each broken link you can see the following details:</p>
                <ul className="list">
                  <li className="list__item"><span className="body1--bold">Url</span> - this is the broken url</li>
                  <li className="list__item"><span className="body1--bold">Views</span> - this is the number of times a broken url has been visited</li>
                </ul>
              </li>
              <li className="medium-spacing--top">Push <BuildIcon className="in-text-icon" /> to create a redirect to a different url</li>
              <li className="medium-spacing--top">Push <VisibilityIcon className="in-text-icon" /> / <VisibilityOffIcon className="in-text-icon"/> to ignore / unignore the urls that doe not require a fix</li>
            </ol>
            <h3 className="xlarge-spacing2--top">Learn More</h3>
            <ul className="icon-font-list xlarge-spacing2--bottom">
              <HelpLink
                title="Where should I redirect broken links?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534823014804-Where-should-I-redirect-broken-links"
              />
              <HelpLink
                title="How do broken link redirects help my SEO?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534839771540-How-do-broken-link-redirects-help-my-SEO"
              />
            </ul>
            <Button
              label='Close'
              buttonType="secondary"
              onTouchTap={() => this.setState({ showHelpModal: false })}
            />
          </div>
        </ResponsiveDialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checks/NotFoundDetailsHeader.js